import logo from './logo.svg';
import './App.css';
import Routing from './routing/Routing';
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function App() {
  return (
    <Routing />
  );
}

export default App;
